import { Ticket, ArrowRight } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal, Overline } from "./Reveal";

export const Tickets = () => {
  const { t } = useLang();

  return (
    <section id="tickets" data-testid="tickets-section" className="relative overflow-hidden bg-pine py-24 text-cream md:py-32">
      <div className="pointer-events-none absolute -right-28 -top-28 h-[26rem] w-[26rem] rounded-full border border-gold/20" />
      <div className="pointer-events-none absolute -right-14 -top-14 h-[26rem] w-[26rem] rounded-full border border-gold/10" />
      <div className="pointer-events-none absolute -bottom-32 -left-32 h-[22rem] w-[22rem] rounded-full border border-cream/10" />

      <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-12 px-6 md:px-14 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <Overline dark>{t.tickets.overline}</Overline>
            <h2 className="mt-5 font-serif text-4xl font-medium italic leading-[1.05] tracking-tight md:text-6xl">
              {t.tickets.title}
            </h2>
            <p className="mt-6 max-w-lg leading-relaxed text-cream/70">{t.tickets.text}</p>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:text-right">
          <Reveal delay={0.15}>
            <a
              href="#participate"
              data-testid="tickets-notify-btn"
              className="group inline-flex items-center gap-3 bg-gold px-9 py-4 text-[12px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-500 hover:bg-cream"
            >
              <Ticket size={16} />
              {t.tickets.cta}
              <ArrowRight size={15} className="transition-transform duration-500 group-hover:translate-x-1" />
            </a>
            <p className="mt-4 text-xs italic text-cream/50">{t.tickets.note}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
